module.exports = __webpack_public_path__ + "img/icon-right.1dc7bcbe.svg";